'use strict';
/* global require */

angular
  .module('autoProduct')
  .component('autoProduct', {
    template: require('./auto-product.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService',
      function AutoProductController($rootScope, $resource, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'autoProduct';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.isLevel2Authenticated();
        this.config = {
          enabled: true,
          country: 'TH',
          title_en: 'Auto Product',
          title_th: 'Auto Product',
          items: [],
        };

        this._enabled = (value) => {
          if (value === false || value === 0 || value === '0') return false;
          if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'false' || v === 'off' || v === 'no' || v === '') return false;
          }
          return true;
        };

        this.itemLabel = (item) => {
          if (!item) return '';
          if (item.key === 'insurance') return 'ประกัน (Insurance)';
          if (item.key === 'subscription') return 'Subscription Package';
          return item.key;
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/auto-product`)
            .get()
            .$promise
            .then((data) => {
              this.config = {
                enabled: this._enabled(data.enabled),
                country: data.country || 'TH',
                title_en: data.title_en || 'Auto Product',
                title_th: data.title_th || 'Auto Product',
                items: (data.items || []).map((i) => Object.assign({}, i, {
                  enabled: this._enabled(i.enabled),
                })),
              };
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.load();

        this.toggleItem = (item) => {
          if (!this.isLevel2Auth || !item) return;
          item.enabled = !this._enabled(item.enabled);
        };

        this.save = () => {
          if (!this.isLevel2Auth) return;
          if (!confirm('Save Auto Product config?')) return;

          const payload = {
            enabled: this._enabled(this.config.enabled),
            country: (this.config.country || 'TH').toUpperCase(),
            title_en: this.config.title_en || 'Auto Product',
            title_th: this.config.title_th || 'Auto Product',
            items: (this.config.items || []).map((i, idx) => ({
              key: i.key,
              enabled: this._enabled(i.enabled),
              title_en: i.title_en || '',
              title_th: i.title_th || '',
              image_url: i.image_url || '',
              sort: idx,
            })),
          };

          const Res = $resource(`${APIURL}/admin/services/apps/auto-product`, {}, {
            update: { method: 'PUT' },
          });
          Res.update(payload)
            .$promise
            .then((data) => {
              this.config = {
                enabled: this._enabled(data.enabled),
                country: data.country || 'TH',
                title_en: data.title_en || 'Auto Product',
                title_th: data.title_th || 'Auto Product',
                items: (data.items || []).map((i) => Object.assign({}, i, {
                  enabled: this._enabled(i.enabled),
                })),
              };
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/service/auto-product/auto-product.component.js